import { constantRouterMap, headerServiceMap, footerServiceMap, dashboardRoute } from '@/router'

/**
 * 通过管理端类型过滤路由表
 */
function filterPlatformBaseRoute() {
  return [dashboardRoute.system, ...headerServiceMap, ...footerServiceMap]
}

/**
 * 判断是否与当前用户权限匹配
 * @param menu
 * @param route
 */
function hasPermission(menu, route) {
  const routeArr = route.id ? route.id.split(',') : route.children.map((item) => item.id)

  return menu.find((item) => routeArr.findIndex((routeId) => routeId === item) >= 0)
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param asyncRouterMap
 * @param roles
 */
function filterAsyncRouter(serviceMap, menu) {
  const accessedRouters = serviceMap.filter((route) => {
    const result = hasPermission(menu, route)

    if (result) {
      if (route.children && route.children.length > 1) {
        route.children = filterAsyncRouter(route.children, menu)
      }

      return true
    }

    return false
  })

  return accessedRouters
}

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: [],
    filterRouters: []
  },

  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = constantRouterMap.concat(routers)
    },

    SET_FILTER_ROUTERS: (state, routers) => {
      state.filterRouters = routers
    }
  },

  actions: {
    generateRoutes({ commit }, data) {
      return new Promise((resolve) => {
        const filterBaseRoute = filterPlatformBaseRoute()
        const accessedRouters = filterAsyncRouter(filterBaseRoute, data)

        commit('SET_FILTER_ROUTERS', accessedRouters)

        // 判断是否拥有浏览首页的权限，没有则插入空白的首页
        const haveDashboardPage = accessedRouters.findIndex(
          (route) => route.name && route.name.startsWith('dashboard-')
        )
        if (!accessedRouters.length || haveDashboardPage === -1) {
          accessedRouters.splice(0, 0, dashboardRoute.empty)
        }

        commit('SET_ROUTERS', accessedRouters)
        resolve()
      })
    }
  }
}

export default permission
